import { gql } from '@apollo/client';
export const LIST_TRIPS = gql `
  query ListTrips($listTripsInput: ListTripsInput!) {
    listTrips(listTripsInput: $listTripsInput) {
      total
      items {
        id
        cost
        currency
        paymentType
        humanId
        completedAt
        clientName
        clientPhone
        comment
        pickUpDateTime
        commentForDriver
        routePoints {
          address
          role
        }
        complaint {
          status
        }
        car {
          licensePlate
          model
        }
      }
    }
  }
`;
export const LIST_PLANNED_TRIPS = gql `
  query ListPlannedTrips($listPlannedTripsInput: ListPlannedTripsInput) {
    listPlannedTrips(listPlannedTripsInput: $listPlannedTripsInput) {
      items {
        id
        status
        humanId
        paymentType
        currency
        cost
        clientName
        clientPhone
        plannedPickUpAt
        plannedTripStartBefore
        commentForDriver
        canReject
        routePoints {
          address
          role
        }
      }
    }
  }
`;
export const LIST_PLANNED_TRIPS_FOR_HOME = gql `
  query ListPlannedTrips($listPlannedTripsInput: ListPlannedTripsInput) {
    listPlannedTrips(listPlannedTripsInput: $listPlannedTripsInput) {
      items {
        id
        status
        plannedPickUpAt
      }
    }
  }
`;
export const ACCEPT_PLANNED_TRIP = gql `
  mutation AcceptPlannedTrip($acceptPlannedTripInput: AcceptPlannedTripInput!) {
    acceptPlannedTrip(acceptPlannedTripInput: $acceptPlannedTripInput) {
      success
    }
  }
`;
export const START_PLANNED_TRIP = gql `
  mutation StartPlannedTrip($startPlannedTripInput: StartPlannedTripInput!) {
    startPlannedTrip(startPlannedTripInput: $startPlannedTripInput) {
      success
    }
  }
`;
export const REJECT_PLANNED_TRIP = gql `
  mutation RejectPlannedTripV2($rejectPlannedTripInput: RejectPlannedTripInput!) {
    rejectPlannedTripV2(rejectPlannedTripInput: $rejectPlannedTripInput) {
      success
    }
  }
`;
